// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__IzGG5","box__wrapper":"modal_box__wrapper__RYGof","box":"modal_box__suXU0","backdrop__close":"modal_backdrop__close__EDhJH"};